import { render, staticRenderFns } from "./Widebody.vue?vue&type=template&id=f8027a8a&scoped=true"
import script from "./Widebody.vue?vue&type=script&lang=js"
export * from "./Widebody.vue?vue&type=script&lang=js"
import style0 from "./Widebody.vue?vue&type=style&index=0&id=f8027a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8027a8a",
  null
  
)

export default component.exports